import { render } from "./ApLoader.vue?vue&type=template&id=855cb862&scoped=true&ts=true"
import script from "./ApLoader.vue?vue&type=script&lang=ts"
export * from "./ApLoader.vue?vue&type=script&lang=ts"

import "./ApLoader.vue?vue&type=style&index=0&id=855cb862&scoped=true&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-855cb862"]])

export default __exports__